import { Action } from 'Store/types';
import { ActionTypes, PopUpError } from './types';

const setPopUpError = (popUpError: PopUpError): Action<ActionTypes> => ({
  type: ActionTypes.SET_POPUP_ERROR,
  payload: popUpError,
});

export default setPopUpError;
